import { CompletedTestPlan, TestResults } from '@/app/components/testing-plan/components/completed-testing-plans/types';
import {
  TestOptionDetails,
  TestPlanScreeningType,
} from '@/app/components/testing-plan/components/your-testing-plan/types';
import { UserQuestionnaireType } from '@/components/decision-tree';
import { AnswerModel } from '@/components/decision-tree/hooks';
import apiClient from '../client/api';

type GetTestPlanResponse = {
  recommendations: Array<TestPlanScreeningType>;
  otherConsiderations: Array<TestPlanScreeningType>;
};

type GetTestPlanHistoryResponse = Array<CompletedTestPlan>;

export type PutScreeningQuestionnaireAnswerPayload = {
  surveyItemId: string;
  answerScreeningId: string;
  answer: AnswerModel;
};

async function get(): Promise<GetTestPlanResponse> {
  const res = await apiClient.get('/testing-plan/screenings');
  return res.data;
}

async function getHistory(screeningTypeId: string | null): Promise<GetTestPlanHistoryResponse> {
  const res = await apiClient.get(
    `/user-questionnaires/screening/history${screeningTypeId ? '/' + screeningTypeId : ''}`
  );
  return res.data;
}

async function getTestResults(idTestResults: string): Promise<TestResults> {
  const res = await apiClient.get(`/user-questionnaires/screening/results/${idTestResults}`);
  return res.data;
}

async function getTestOptionDetails(idTestOption: string): Promise<TestOptionDetails> {
  const res = await apiClient.get(`/testing-plan/screening/${idTestOption}`);
  return res.data;
}

async function getTestQuestionnaire(idTestOption: string): Promise<UserQuestionnaireType> {
  const res = await apiClient.get(`/user-questionnaires/screening/current/${idTestOption}`);
  return res.data;
}

async function answerTestQuestionnaire(
  payload: PutScreeningQuestionnaireAnswerPayload
): Promise<UserQuestionnaireType> {
  const res = await apiClient.put(
    `/user-questionnaires/screening/current/${payload.answerScreeningId}/survey-item/${payload.surveyItemId}`,
    payload.answer
  );
  return res.data;
}

async function updateTargetDate(testSuggestionId: string, targetDate: string | null): Promise<void> {
  const res = await apiClient.patch(`/testing-plan/test-suggestion/${testSuggestionId}/target-date`, { targetDate });
  return res.data;
}

async function completeTest(testSuggestionId: string): Promise<void> {
  const res = await apiClient.patch(`/testing-plan/test-suggestion/${testSuggestionId}/complete`);
  return res.data;
}

export default {
  get,
  getHistory,
  getTestResults,
  getTestOptionDetails,
  getTestQuestionnaire,
  answerTestQuestionnaire,
  updateTargetDate,
  completeTest,
};
